export type EditorThreadAnchorType = 'SUGGESTION' | 'TEXT_RANGE'

export type EditorThreadComment = {
  id: string
  threadId: string
  userId: number | null
  userName: string
  body: string
  createdAt: string
}

export type EditorThread = {
  id: string
  anchorType: EditorThreadAnchorType
  anchorId: string
  comments: EditorThreadComment[]
}

export const anchorKey = (anchorType: EditorThreadAnchorType, anchorId: string): string => `${anchorType}:${anchorId}`

/** Mirrors the backend: a thread has no author of its own, so its oldest comment names one. */
export function threadCreatorUserId(thread: EditorThread | null): number | null {
  return thread?.comments[0]?.userId ?? null
}

/**
 * Resolving one's own thread needs only comment access; resolving anyone else's is a reviewer's
 * privilege. An anchor with no thread behind it has nobody to shield, so it stays resolvable.
 * Mirrors `canArchiveThread` on the backend, which is what actually enforces this.
 */
export function canResolveThread(thread: EditorThread | null, currentUserId: number | null, canResolveAny: boolean): boolean {
  if (canResolveAny) {
    return true
  }
  if (thread === null) {
    return true
  }
  return currentUserId !== null && threadCreatorUserId(thread) === currentUserId
}

export type SidebarFilter = 'all' | 'changes' | 'comments'
